import type { ResultsReduxState } from "@app/types/results-redux-types";

import { getResultSearchCount as getResultSearchCountHelper } from "../helpers/get-result-search-count";

export const getResultSearchCount = (state: ResultsReduxState) =>
  getResultSearchCountHelper(
    state.search.outbound_date,
    state.metadata.result_search_stats
  );
